import { DashboardIcon } from 'assets'

export const menuItems = [
   {
      name: 'Dashboard',
      path: '/dashboard',
      faIcon: <DashboardIcon />
   },
   {
      name: 'Videos',
      path: '/videos',
      faIcon: <DashboardIcon />
   },
   // {
   //    name: 'Reels',
   //    path: '/reels',
   //    faIcon: <DashboardIcon />
   // },


]
